// src/components/Terms.jsx
import { getUserLanguage } from '../utils/language';
import Navbar from '../components/common/NavBar';
import MiniHero from '../components/common/MiniHero';
import Footer from '../components/common/Footer';

const Terms = () => {
  const language = getUserLanguage();

  const texts = {
    cs: {
      title: 'Podmínky užití',
      intro:
        'Vítejte na podmínkách užití webových stránek NO RISK NO DRIFT. Tyto podmínky upravují používání našeho webu a e-shopu.',
      sections: {
        intro: {
          title: '1. Úvod',
          content:
            'Tyto podmínky užití (dále jen "Podmínky") platí pro všechny návštěvníky a uživatele webových stránek NO RISK NO DRIFT (dále jen "Stránky") a našeho e-shopu. Používáním Stránek nebo nákupem v e-shopu souhlasíte s těmito Podmínkami. Pokud s nimi nesouhlasíte, prosím, Stránky nepoužívejte.',
        },
        rights: {
          title: '2. Práva a povinnosti uživatelů',
          content:
            'Uživatelé se zavazují používat Stránky a e-shop v souladu s platnými zákony České republiky. Je zakázáno využívat Stránky k nelegálním účelům, šíření nepravdivých informací nebo poškození pověsti týmu NO RISK NO DRIFT.',
        },
        eshop: {
          title: '3. Podmínky e-shopu',
          content:
            'Nákup v e-shopu je podmíněn registrací nebo jednorázovým zadáním kontaktních údajů. Všechny ceny jsou uvedeny včetně DPH. Objednávky jsou závazné po potvrzení platby. Dodací lhůta je obvykle 3–7 pracovních dní, pokud není uvedeno jinak. Zboží zůstává majetkem NO RISK NO DRIFT až do úplného zaplacení.',
        },
        returns: {
          title: '4. Vrácení zboží a reklamace',
          content:
            'Na zboží zakoupené v e-shopu máte právo na vrácení do 14 dnů od doručení bez udání důvodu, pokud je zboží nepoužité a v původním obalu. Náklady na vrácení hradí kupující. Reklamace vadného zboží řešíme v souladu s českým právem – kontaktujte nás na e-mail uvedený v sekci Kontakt.',
        },
        ip: {
          title: '5. Duševní vlastnictví',
          content:
            'Veškerý obsah Stránek (texty, fotografie, videa, loga) je chráněn autorským právem a je majetkem NO RISK NO DRIFT nebo našich partnerů. Bez předchozího písemného souhlasu není povoleno kopírování, šíření ani komerční využití obsahu.',
        },
        liability: {
          title: '6. Omezení odpovědnosti',
          content:
            'NO RISK NO DRIFT nenese odpovědnost za škody způsobené nesprávným použitím zakoupeného zboží nebo přerušením dostupnosti Stránek z důvodu technických problémů. Informace na Stránkách jsou poskytovány "jak jsou" bez záruky úplnosti či přesnosti.',
        },
        disputes: {
          title: '7. Řešení sporů',
          content:
            'Tyto Podmínky se řídí právem České republiky. Spory budou řešeny přednostně mimosoudně, v případě neúspěchu u příslušného soudu v České republice.',
        },
        changes: {
          title: '8. Změny podmínek',
          content:
            'Vyhrazujeme si právo tyto Podmínky kdykoliv změnit. Aktualizovaná verze bude zveřejněna na Stránkách a platí od data zveřejnění.',
        },
      },
    },
    en: {
      title: 'Terms and Conditions',
      intro:
        'Welcome to the Terms and Conditions of the NO RISK NO DRIFT website. These terms govern the use of our website and e-shop.',
      sections: {
        intro: {
          title: '1. Introduction',
          content:
            'These Terms and Conditions (hereinafter "Terms") apply to all visitors and users of the NO RISK NO DRIFT website (hereinafter "Site") and our e-shop. By using the Site or purchasing from the e-shop, you agree to these Terms. If you do not agree, please do not use the Site.',
        },
        rights: {
          title: '2. User Rights and Obligations',
          content:
            'Users undertake to use the Site and e-shop in accordance with the applicable laws of the Czech Republic. It is prohibited to use the Site for illegal purposes, spreading false information, or damaging the reputation of NO RISK NO DRIFT.',
        },
        eshop: {
          title: '3. E-shop Terms',
          content:
            'Purchases in the e-shop require registration or one-time entry of contact details. All prices include VAT. Orders are binding upon payment confirmation. Delivery time is typically 3–7 working days unless stated otherwise. Goods remain the property of NO RISK NO DRIFT until fully paid.',
        },
        returns: {
          title: '4. Returns and Complaints',
          content:
            'You have the right to return goods purchased from the e-shop within 14 days of delivery without stating a reason, provided the goods are unused and in original packaging. Return shipping costs are borne by the buyer. Defective goods complaints are handled in accordance with Czech law – contact us via the email in the Contact section.',
        },
        ip: {
          title: '5. Intellectual Property',
          content:
            'All content on the Site (texts, photos, videos, logos) is protected by copyright and is the property of NO RISK NO DRIFT or our partners. Copying, distributing, or commercial use of the content is not permitted without prior written consent.',
        },
        liability: {
          title: '6. Limitation of Liability',
          content:
            'NO RISK NO DRIFT is not liable for damages caused by improper use of purchased goods or Site downtime due to technical issues. Information on the Site is provided "as is" without guarantees of completeness or accuracy.',
        },
        disputes: {
          title: '7. Dispute Resolution',
          content:
            'These Terms are governed by Czech law. Disputes will be resolved preferably out of court; if unsuccessful, they will be settled by the competent court in the Czech Republic.',
        },
        changes: {
          title: '8. Changes to Terms',
          content:
            'We reserve the right to amend these Terms at any time. The updated version will be published on the Site and takes effect from the date of publication.',
        },
      },
    },
  };

  // Nastavení patičky (můžete nahradit dynamickým načítáním, pokud je to potřeba)
  const footerSettings = {
    instagram: 'https://instagram.com/norisknodrift',
    facebook: 'https://facebook.com/norisknodrift',
    youtube: 'https://youtube.com/norisknodrift',
    tiktok: 'https://tiktok.com/@norisknodrift',
  };

  const currentText = texts[language] || texts.en;

  return (
    <div className="min-h-screen bg-black">
      {/* Navigační lišta */}
      <Navbar language={language} />

      {/* MiniHero sekce */}
      <MiniHero title={currentText.title} description={currentText.intro} />

      {/* Hlavní obsah */}
      <div className="container mx-auto px-4 py-10 text-white">
        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">{currentText.sections.intro.title}</h2>
          <p className="text-gray-400">{currentText.sections.intro.content}</p>
        </section>
        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">{currentText.sections.rights.title}</h2>
          <p className="text-gray-400">{currentText.sections.rights.content}</p>
        </section>
        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">{currentText.sections.eshop.title}</h2>
          <p className="text-gray-400">{currentText.sections.eshop.content}</p>
        </section>
        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">{currentText.sections.returns.title}</h2>
          <p className="text-gray-400">{currentText.sections.returns.content}</p>
        </section>
        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">{currentText.sections.ip.title}</h2>
          <p className="text-gray-400">{currentText.sections.ip.content}</p>
        </section>
        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">{currentText.sections.liability.title}</h2>
          <p className="text-gray-400">{currentText.sections.liability.content}</p>
        </section>
        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">{currentText.sections.disputes.title}</h2>
          <p className="text-gray-400">{currentText.sections.disputes.content}</p>
        </section>
        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">{currentText.sections.changes.title}</h2>
          <p className="text-gray-400">{currentText.sections.changes.content}</p>
        </section>
      </div>

      {/* Patička */}
      <Footer
        instagram={footerSettings.instagram}
        facebook={footerSettings.facebook}
        youtube={footerSettings.youtube}
        tiktok={footerSettings.tiktok}
      />
    </div>
  );
};

export default Terms;
